<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
  >
    <v-card>
      <v-card-title
        class="title pt-5 pb-0"
        primary-title
      >
        Confirmação
      </v-card-title>

      <v-card-text
        class="pt-3"
      >
        <p>
          Declaro que <strong class="primary--text">
            {{ dadosPessoais.form.nomeFavorecido }},
          </strong>
          portador(a) do
          <strong class="primary--text">
            {{ dadosPessoais.form.radios | textoMaiusculo }}
          </strong>
          <strong class="primary--text">
            {{ dadosPessoais.form.fieldCpfCnpj }},
          </strong>
          é o(a) titular da conta <strong class="primary--text">
            {{ tipoConta }} {{ contaCorrente }},
          </strong>
          agência <strong class="primary--text">
            {{ agencia }},
          </strong>
          no banco <strong class="primary--text">
            {{ dadosBancarios.form.bankName }}.
          </strong>
        </p>
        <p>
          Você confirma que as informações acima estão corretas?
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          data-cy="btn_nao_confirmo_dados"
          @click="dadosVerificados(false)"
        >
          Não
        </v-btn>
        <v-btn
          color="primary"
          text
          data-cy="btn_confirmo_dados"
          @click="dadosVerificados(true)"
        >
          Sim
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ModalConfirmacaoDados',

  props: {
    index: {
      type: Number,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
    dadosPessoais: {
      type: Object,
      required: true,
    },
    dadosBancarios: {
      type: Object,
      required: true,
    },
  },

  computed: {
    contaCorrente() {
      const dadosDoBanco = this.dadosBancarios.form;
      if (dadosDoBanco.accountCheckNumber) return `${dadosDoBanco.accountNumber}-${dadosDoBanco.accountCheckNumber}`;

      return dadosDoBanco.accountNumber;
    },

    tipoConta() {
      const dadosDoBanco = this.dadosBancarios.form;
      if (dadosDoBanco.tipoConta === '1') return 'Corrente';

      return 'Poupança';
    },

    agencia() {
      const dadosDoBanco = this.dadosBancarios.form;
      if (dadosDoBanco.agencyCheckNumber) return `${dadosDoBanco.agencyNumber}-${dadosDoBanco.agencyCheckNumber}`;

      return dadosDoBanco.agencyNumber;
    },
  },

  methods: {
    dadosVerificados(avancar) {
      const irPara = avancar ? this.index + 1 : this.index - 1;

      this.$emit('infoVerificadas', irPara);
      this.$emit('changeDialog', false);
    },
  },
};
</script>
